import { Component, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';
declare var $: any;
@Component({
  selector: 'app-wealth-calculators',
  templateUrl: './wealth-calculators.component.html',
  styleUrls: ['./wealth-calculators.component.scss', './../ifacss.scss']
})
export class WealthCalculatorsComponent implements OnInit {
  //  Calculator SIP
  sipcalformSubmitted: boolean = false;
  InvestedAmount: any = 10000;
  InvestmentPeriod: any = 12;
  ExpectedReturns: any = 10;
  FutureValue: number;
  FutureGain: number;
  InvestmentPercent: number;
  GainPercent: number;
  // Lumpsum
  InvestedAmountLumpsum: any = 10000;
  InvestmentPeriodLumpsum: any = 2;
  ExpectedReturnsLumpsum: any = 10;
  FutureValueLumpsum: number;
  FutureGainLumpsum: number;
  InvestmentPercentLumpsum: number;
  GainPercentLumpsum: number;
  IsSIP: boolean = true;
  IsLumpsum: boolean = false;
  GoalType: string = '';
  constructor() {}

  ngOnInit(): void {
    $(document).ready(function () {
      $('.numonly').on('input', function () {
        var regexp = /[^\d\.\-]/g;
        if ($(this).val().match(regexp)) {
          $(this).val($(this).val().replace(regexp, ''));
        }
      });
    });
    this.OnChangeCalculator();
    this.OnChangeCalculatorLumpSum();
  }
  OnChangeCalculator() {
    debugger;
    let data: any;
    let convertmonthly = Number(this.ExpectedReturns / 12);
    let Return = Number(convertmonthly / 100);
    let Power = Math.pow(1 + Return, this.InvestmentPeriod);
    let Investment = this.InvestedAmount * this.InvestmentPeriod;
    let cal: any = [(Power - 1) / Return];
    this.FutureValue = Math.round(this.InvestedAmount * cal * (1 + Return));
    this.FutureGain = this.FutureValue - Investment;
    this.InvestmentPercent = (Investment / this.FutureValue) * 100;
    this.GainPercent = 100 - this.InvestmentPercent;
    data = [
      {
        name: 'Investent',
        y: this.InvestmentPercent,
        color: '#0e75bd'
      },
      {
        name: 'Earnings',
        y: this.GainPercent,
        color: '#fab505'
      }
    ];

    this.BindChartSIP(data);
  }
  OnChangeCalculatorLumpSum() {
    debugger;
    let data1: any;
    let Return = this.ExpectedReturnsLumpsum / 100;
    let Power = Math.pow(1 + Return, this.InvestmentPeriodLumpsum);
    this.FutureValueLumpsum = Math.round(this.InvestedAmountLumpsum * Power);
    this.FutureGainLumpsum =
      this.FutureValueLumpsum - this.InvestedAmountLumpsum;
    this.InvestmentPercentLumpsum =
      (this.InvestedAmountLumpsum / this.FutureValueLumpsum) * 100;
    this.GainPercentLumpsum = 100 - this.InvestmentPercentLumpsum;
    data1 = [
      {
        name: 'Investent',
        y: this.InvestmentPercentLumpsum,
        color: '#0e75bd'
      },
      {
        name: 'Earnings',
        y: this.GainPercentLumpsum,
        color: '#fab505'
      }
    ];
    this.BindChartLumpsum(data1);
  }
  BindChartSIP(data) {
    let Options: any = {
      chart: {
        backgroundColor: '#fcfcfc',
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
      },
      title: {
        text: ''
      },
      credits: {
        enabled: false
      },
      // tooltip: {
      //   pointFormat: '{series.name} <b>{point.IndCurrVal}</b>'
      // },
      series: [
        {
          name: '',
          data: data
        }
      ],
      plotOptions: {
        pie: {
          startAngle: 180,
          innerSize: '70%',
          size: '100%',
          dataLabels: !1,
          stickyTracking: !1,
          slicedOffset: 10,
          states: {
            hover: {
              enabled: !1
            },
            inactive: {
              opacity: 1
            }
          }
        }
      }
    };
    Highcharts.chart('SipChart1', Options);
  }
  BindChartLumpsum(data) {
    let Options1: any = {
      chart: {
        backgroundColor: '#fcfcfc',
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
      },
      title: {
        text: ''
      },
      credits: {
        enabled: false
      },
      // tooltip: {
      //   pointFormat: '{series.name} <b>{point.IndCurrVal}</b>'
      // },
      series: [
        {
          name: '',
          data: data
        }
      ],
      plotOptions: {
        pie: {
          startAngle: 180,
          innerSize: '70%',
          size: '100%',
          dataLabels: !1,
          stickyTracking: !1,
          slicedOffset: 10,
          states: {
            hover: {
              enabled: !1
            },
            inactive: {
              opacity: 1
            }
          }
        }
      }
    };
    Highcharts.chart('LumpsumChart', Options1);
  }
  onInvestedAmountValue(e) {
    debugger;
    console.log('Invested Amount ', e);
    this.InvestedAmount = Number(e);
  }

  onInvestmentPeriodValue(e) {
    this.InvestmentPeriod = Number(e);
  }

  onExpectedReturnsValue(e) {
    this.ExpectedReturns = Number(e);
  }
  onInvestedAmountValueLumpsum(e) {
    debugger;
    console.log('Invested Amount ', e);
    this.InvestedAmountLumpsum = Number(e);
  }

  onInvestmentPeriodValueLumpsum(e) {
    this.InvestmentPeriodLumpsum = Number(e);
  }

  onExpectedReturnsValueLumpsum(e) {
    this.ExpectedReturnsLumpsum = Number(e);
  }
}
